import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {useSelector} from 'hooks/redux'
import {downloadFile} from 'libs/downloadFile'
import {asyncError} from 'store/actions/asyncError'
import {dateFormat} from 'libs/formatter'
import {DownloadFile} from 'jbc-front/components/icons'
import {Hint} from 'jbc-front/components/presenters/ui/Hint'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {Table} from 'components/ui/Table'
import {fullName} from '../Presenter'
import {ContractInfo, Employee, Document, ContractInfoStatus} from '../query'
import styles from './Row.scss'

interface DownloadButtonProps {
  documentId: string
  employeeId: string
}

const DownloadButton: FC<DownloadButtonProps> = ({documentId, employeeId}) => {
  const dispatch = useDispatch()
  const selectedOffices = useSelector((state) => state.session.selectedOffices)
  const handleClickDownload = async () => {
    await downloadFile({
      url: `/api/documents/${documentId}/document_sign_transactions/${employeeId}/signed_document`,
      asyncError: (err) => dispatch(asyncError(err)),
      usePost: false,
      selectedOffices,
    })
  }
  return (
    <div className={styles.downloadButton} onClick={handleClickDownload}>
      <DownloadFile size={14} color="#fff" className={styles.downloadFileIcon} />
    </div>
  )
}

const convertContractStatus = (status: ContractInfoStatus) => {
  switch (status) {
    case 'signed':
      return '署名済'
    case 'unsigned':
      return '未署名'
    case 'canceled':
      return <span className={styles.canceledText}>取消済</span>
    default:
      return '対象外'
  }
}

interface RowProps {
  document: Document
  employee: Employee
  contractInfo: ContractInfo
}

export const Row: FC<RowProps> = ({document, employee, contractInfo}) => {
  const status = contractInfo.status

  return (
    <Table.Tr>
      <Table.Td>{dateFormat(document.createdAt, 'L')}</Table.Td>
      <Table.Td>{document.title}</Table.Td>
      <Table.Td>{fullName(document.createdUser)}</Table.Td>
      <Table.Td>{convertContractStatus(status)}</Table.Td>
      <Table.Td>
        {status === 'signed' ? (
          contractInfo?.downloadableSignedDocument ? (
            <DownloadButton documentId={document.id} employeeId={employee.id} />
          ) : (
            <div className={styles.hintWrap}>
              準備中
              <Spacer direction="x" size={5} />
              <Hint leftPoint={-200}>ダウンロードの準備をしています。時間をおいて再度ご確認ください。</Hint>
            </div>
          )
        ) : null}
      </Table.Td>
    </Table.Tr>
  )
}
